var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ns-date-picker" },
    [
      _c(
        "VMenu",
        {
          attrs: {
            "close-on-content-click": false,
            "full-width": "",
            lazy: "",
            "min-width": _vm.width,
            "content-class": "ns-date-picker-wrapper"
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "VInput",
                    {
                      attrs: {
                        value: _vm.pickerDate,
                        rules: _vm.rules,
                        oncontextmenu: "return false;"
                      },
                      on: { paste: _vm.handlePaste }
                    },
                    [
                      _c(
                        "NsTextField",
                        _vm._g(
                          _vm._b(
                            {
                              ref: "datePickerTextField",
                              attrs: {
                                value: _vm.computedDateFormatted,
                                label: _vm.label,
                                clearable: _vm.clearable,
                                required: _vm.required,
                                readonly: ""
                              },
                              on: {
                                clear: _vm.handleClear,
                                blur: _vm.handleBlur,
                                keydown: _vm.handleKeyDown,
                                keyup: _vm.handleKeyUp
                              }
                            },
                            "NsTextField",
                            attrs,
                            false
                          ),
                          on
                        )
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.showMenu,
            callback: function($$v) {
              _vm.showMenu = $$v
            },
            expression: "showMenu"
          }
        },
        [
          _vm._v(" "),
          _c("VDatePicker", {
            ref: "picker",
            attrs: {
              "no-title": "",
              width: _vm.width,
              "first-day-of-week": _vm.firstDayOfWeek,
              locale: _vm.locale,
              color: _vm.color,
              min: _vm.min,
              max: _vm.maxDate,
              type: _vm.type,
              "next-icon": "$vuetify.icons.date-next",
              "prev-icon": "$vuetify.icons.date-prev"
            },
            on: {
              input: function($event) {
                _vm.showMenu = false
              }
            },
            model: {
              value: _vm.pickerDate,
              callback: function($$v) {
                _vm.pickerDate = $$v
              },
              expression: "pickerDate"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }